// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yGEQX","label":"styles_label__34GVq"};